import PropTypes from 'prop-types';
import React, { useCallback, useMemo } from 'react';
import { connect } from 'react-redux';
import { newBookingOverlayType } from 'constants/new-booking-constants';
import { deliveryDetailOverlaySelector } from 'selectors/new-booking-selectors';
import NewBookingDuck from 'ducks/new-booking-duck';
import {
  PickUpAddressSelector,
  DropOffAddressSelector,
} from './address-selector';
import ServiceConfigurationPanel from './service-configuration-panel';
import OfferListOverLay from './offer-list';
import CommonOverlay from './common-overlay';
import MSDDeliveryGuaranteePanel from './msd-delivery-guarantee-panel';
import DeliveryGuaranteeTncPanel from './delivery-guarantee-tnc-panel';

const DeliveryDetailOverlay = ({ dispatch, detailOverlay }) => {
  const { visible = false, deliveryID, overlayType } = detailOverlay;

  const onClose = useCallback(
    () => {
      dispatch(NewBookingDuck.creators.closeDetailOverlay());
    },
    [overlayType],
  );

  const ContentComponent = useMemo(
    () => {
      switch (overlayType) {
        case newBookingOverlayType.pickUpAddress:
          return PickUpAddressSelector;
        case newBookingOverlayType.dropOffAddress:
          return DropOffAddressSelector;
        case newBookingOverlayType.serviceConfiguration:
          return ServiceConfigurationPanel;
        case newBookingOverlayType.offerConfiguration:
          return OfferListOverLay;
        case newBookingOverlayType.deliveryGuarantee:
          return MSDDeliveryGuaranteePanel;
        case newBookingOverlayType.deliveryGuaranteeTnc:
          return DeliveryGuaranteeTncPanel;
      }
      return null;
    },
    [overlayType],
  );

  return (
    <CommonOverlay
      overlayKey={`${overlayType}-${deliveryID}`}
      visible={visible}
      onClose={onClose}
    >
      {ContentComponent && (
        <ContentComponent deliveryID={deliveryID} onClose={onClose} />
      )}
    </CommonOverlay>
  );
};

DeliveryDetailOverlay.propTypes = {
  detailOverlay: PropTypes.shape({
    deliveryID: PropTypes.string,
    overlayType: PropTypes.string,
    visible: PropTypes.bool,
  }),
  dispatch: PropTypes.func.isRequired,
};

DeliveryDetailOverlay.defaultProps = {
  detailOverlay: undefined,
};

export default connect(state => ({
  detailOverlay: deliveryDetailOverlaySelector(state),
}))(DeliveryDetailOverlay);
